/**
 * Block JWT persistence in localStorage (HttpOnly cookies are the session).
 * Purges any legacy tokens on startup.
 */
import { HQ_PORTALS, portalStoragePrefix, stripAllPortalJwtsFromStorage } from './storage';

const AUTH_TOKEN_SUFFIX = '_AUTH_TOKEN';

function isAuthTokenKey(key) {
  return typeof key === 'string' && key.includes(AUTH_TOKEN_SUFFIX);
}

export function installSecurePortalStorage() {
  if (typeof window === 'undefined' || window.__enterpriseSecureStorageInstalled) return;
  window.__enterpriseSecureStorageInstalled = true;

  stripAllPortalJwtsFromStorage();
  HQ_PORTALS.forEach((portal) => {
    try {
      localStorage.removeItem(`${portalStoragePrefix(portal)}AUTH_TOKEN`);
    } catch {
      /* ignore */
    }
  });
  try {
    localStorage.removeItem('enterprise_salon_AUTH_TOKEN');
    localStorage.removeItem('enterprise_nxtface_AUTH_TOKEN');
  } catch {
    /* ignore */
  }

  const proto = window.Storage?.prototype;
  if (!proto) return;

  const origGet = proto.getItem;
  const origSet = proto.setItem;

  proto.getItem = function getItem(key) {
    if (isAuthTokenKey(key)) return null;
    return origGet.call(this, key);
  };

  proto.setItem = function setItem(key, value) {
    if (isAuthTokenKey(key)) return;
    return origSet.call(this, key, value);
  };
}
